import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromNav from '../reducers/nav.reducer';

export const getNavState = createSelector(fromFeature.getNavState, (state: fromNav.NavState) => state);

export const getFiltersOpen = createSelector(getNavState, (state: fromNav.NavState) => state.filtersOpen);
export const getMenuOpen = createSelector(getNavState, (state: fromNav.NavState) => state.menuOpen);
export const getTheme = createSelector(getNavState, (state: fromNav.NavState) => state.theme);
export const getNavTransparency = createSelector(getNavState, (state: fromNav.NavState) => state.transparent);
export const getCartPaneOpen = createSelector(getNavState, (state: fromNav.NavState) => state.cartPaneOpen);
export const getSearchOpen = createSelector(getNavState, (state: fromNav.NavState) => state.searchOpen);

export const getChatStatus = createSelector(getNavState, (state: fromNav.NavState) => state.chatStatus);
